// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"8b83a3fc","303":"e4250a30","474":"66457025","612":"5454f16b","929":"fdb49e13"}[chunkId] + ".chunk.js";
};